<template>
    <div>
        <loading v-if="loading"></loading>
        <vue-apex-charts v-if="!loading" type="line" height="500" :options="chartOptions" :series="series"></vue-apex-charts>
    </div>
</template>
<script>
    // import initFilterModel from '@/shared/filter';
    // import {formatDate, parseDate} from '@/shared/utils';
    import VueApexCharts from 'vue-apexcharts'
    import Loading from '@/views/Loading';

    // export const
    export default {
        name: "MixedBarChart",
        props: {
            source: Object,
            title: String,
        },
        components: {
            VueApexCharts,
            Loading
        },
        data() {
            return {
                loading: false,
                series: [
                    {
                        name: 'Хизмат хакки',
                        type: 'column',
                        data: [0, 0, 0]
                    }, {
                        name: 'Туланган',
                        type: 'column',
                        data: [0, 0, 0]
                    }, {
                        name: 'Revenue',
                        type: 'column',
                        data: [0, 0, 0]
                    }
                ],
                chartOptions: {
                    dataLabels: {
                        enabled: false
                    },

                    stroke: {
                        width: [1, 1, 4]
                    },
                    title: {
                        text: this.$props.title,
                        align: 'left',
                        offsetX: 110
                    },
                    xaxis: {
                        // categories: [2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016],
                        categories: ['Мажбурий ижро бюроси', 'Божхона бошқармаси', 'Бошқа'],
                    },
                    yaxis: [
                        {
                            seriesName: 'Cashflow',
                            axisTicks: {
                                show: true,
                            },
                            axisBorder: {
                                show: true,
                                color: '#008FFB'
                            },
                            labels: {
                                style: {
                                    color: '#008FFB',
                                }
                            },
                            title: {
                                text: "Income (thousand crores)",
                                style: {
                                    color: '#008FFB',
                                }
                            },
                            tooltip: {
                                enabled: true
                            }
                        },
                        {
                            seriesName: 'Хизмат хакки',//'Income',
                            opposite: true,
                            axisTicks: {
                                show: true,
                            },
                            axisBorder: {
                                show: true,
                                color: '#00E396'
                            },
                            labels: {
                                style: {
                                    color: '#00E396',
                                }
                            },
                            title: {
                                text: "Operating Cashflow (thousand crores)",
                                style: {
                                    color: '#00E396',
                                }
                            },
                        },
                        {
                            seriesName: 'Колдик',
                            // opposite: true,
                            axisTicks: {
                                show: true,
                            },
                            axisBorder: {
                                show: true,
                                color: '#FEB019'
                            },
                            labels: {
                                style: {
                                    color: '#FEB019',
                                },
                            },
                            title: {
                                text: "Revenue (thousand crores)",
                                style: {
                                    color: '#FEB019',
                                }
                            }
                        }
                    ],
                    tooltip: {
                        fixed: {
                            enabled: true,
                            position: 'topRight', // topRight, topLeft, bottomRight, bottomLeft
                            offsetY: 30,
                            offsetX: 60
                        },
                    },
                    legend: {
                        horizontalAlign: 'left',
                        offsetX: 40
                    }
                }
            }
        },
        methods: {
            initList() {

            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('refreshMixedBarChart', (data) => {
                // console.log(data);
                this.chartOptions = {
                    title: {
                        text: data.barTitle,
                        align: 'left',
                        offsetX: 110
                    }
                };

            });
        },
        computed: {},
        watch: {
            source: function (newVal, oldVal) { // watch it
                console.log('MixedBarChart Prop changed: ', newVal, ' | was: ', oldVal);
                const vm = this;
                vm.loading = true;
                if (newVal) {
                    const object = newVal;
                    // console.log(object);
                    const contractAmountTotal = object;//object.contractAmountTotal;
                    // console.log(contractAmountTotal);
                    this.series = [
                        {
                            name: 'Хизмат хакки',
                            type: 'column',
                            data: [
                                contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.contractAmount,
                                contractAmountTotal.CUSTOMS_ADMINISTRATION.contractAmount,
                                contractAmountTotal.OTHER.contractAmount
                            ]
                        },
                        {
                            name: 'Туланган',
                            type: 'column',
                            data: [
                                contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.paid,
                                contractAmountTotal.CUSTOMS_ADMINISTRATION.paid,
                                contractAmountTotal.OTHER.paid
                            ]
                        },
                        {
                            name: 'Туланмаган',
                            type: 'column',
                            data: [
                                contractAmountTotal.BUREAU_OF_COMPULSORY_EXECUTION.unpaid,
                                contractAmountTotal.CUSTOMS_ADMINISTRATION.unpaid,
                                contractAmountTotal.OTHER.unpaid
                            ]
                        }
                        ];
                    vm.loading = false;
                }

            }
        }
    }
</script>
<style>

</style>

